import React, { PureComponent } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default class SimpleBarChart extends PureComponent {
  render() {
    const { data, nameKey, otherKey, isCount } = this.props;

    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={nameKey ?? "model"} />
          <YAxis />
          {otherKey && <YAxis dataKey={otherKey} orentation="right" stroke="#82ca9d" />}
          <Tooltip />
          <Legend />
          {isCount === true && <Bar dataKey="count" fill="#6B29E1" />}
          {isCount !== true && <Bar dataKey="positive" fill="#008273" />}
          {isCount !== true && <Bar dataKey="negative" fill="#F87171" />}
          {otherKey && <Bar dataKey={otherKey} fill="#82ca9d" />}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
